import { palette } from "./colors";
import { duration, easing } from "./motion";

/** Focus ring and accessibility tokens */
export const focusRing = {
  color: palette.state.focus.ring,
  width: 2,
  offset: 2,
  style: "solid",
} as const;

/** Documented minimum contrast pairs (WCAG AA body text) */
export const contrastPairs = {
  textOnDefault: {
    foreground: palette.text.primary,
    background: palette.background.default,
  },
  textOnPrimary: {
    foreground: palette.brand.primary.contrast,
    background: palette.brand.primary.main,
  },
  textOnError: {
    foreground: palette.semantic.error.contrast,
    background: palette.semantic.error.main,
  },
} as const;

/** Reduced motion is gentler, not zero: keep opacity/color, drop transforms. */
export const reducedMotion = {
  duration: duration.fast,
  easing: easing.hover,
  properties: "opacity",
} as const;

export type TFocusRing = typeof focusRing;
export type TContrastPairs = typeof contrastPairs;
export type TReducedMotion = typeof reducedMotion;
